import "./WhoAmI.module.css";
import EnTeteDeNavigation from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TechnicalExpertise from "./sections/TechnicalExpertise";
import ReadyToTransformProject from "@/pages/PrivacyPolicy/sections/ReadyToTransformProject";
import Footer from "@/reusable_sections/Footer";
import MonApproche from "./sections/MonApproche";
import AutomationDeepDive from "./sections/AutomationDeepDive";
import FeaturesList from "./sections/FeaturesList";
export default function WhoAmIPage() {
  return <div>
      <EnTeteDeNavigation />
      <Hero />
      <TechnicalExpertise />
      <MonApproche />
      <AutomationDeepDive />
      <FeaturesList />
      <ReadyToTransformProject />
      <Footer />
    </div>;
}